import { FolderOutlineOpenIcon } from '@tableau/icons/FolderOutlineOpenIcon';

import * as React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import { LocationTypes } from '../../../models/ILocationInfo';
import { SessionManagementService } from '../../../services/SessionManagementService';
import { DetailsTooltipStyles } from '../DetailsTooltipStyles';
import { EntityLinkProps } from './EntityLink';

import { RelatedEntity } from './RelatedEntity';

export interface LocationFieldProps {
  locationType?: LocationTypes;
  personalSpaceLink: EntityLinkProps;
  projectLink: EntityLinkProps | undefined;
  contentOwnerId?: string;
}

export function LocationField(props: LocationFieldProps) {
  const currentUserId = SessionManagementService.instance.sessionUserId();
  const isOwner = currentUserId === props.contentOwnerId;
  return (
    <>
      {props.locationType === LocationTypes.PersonalSpace ? (
        isOwner ? (
          <RelatedEntity label={Messages.column_location()} link={props.personalSpaceLink} icon={FolderOutlineOpenIcon} />
        ) : (
          <div className={DetailsTooltipStyles.MetadataSmallSection}>
            <span>{Messages.column_location()}</span>
            <span className={DetailsTooltipStyles.MetadataValue}>{Messages.personalSpaceGridLabel()}</span>
          </div>
        )
      ) : (
        props.projectLink && (
          <RelatedEntity label={Messages.column_location()} link={props.projectLink} icon={FolderOutlineOpenIcon}></RelatedEntity>
        )
      )}
    </>
  );
}
